import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { P as PHONE_MASKS, S as SSN_MASK } from './form-input-masks.js';
import { u as updateFormValues, a as updateAddressFormValues, b as updateDateOfBirthFormValues } from './input-handlers.js';
import { d as defineCustomElement$8 } from './custom-popper2.js';
import { d as defineCustomElement$7 } from './form-control-date2.js';
import { d as defineCustomElement$6 } from './form-control-error-text2.js';
import { d as defineCustomElement$5 } from './form-control-number-masked2.js';
import { d as defineCustomElement$4 } from './form-control-select2.js';
import { d as defineCustomElement$3 } from './form-control-text2.js';
import { d as defineCustomElement$2 } from './form-control-tooltip2.js';
import { d as defineCustomElement$1 } from './identity-address-form.js';

const BusinessOwnerFormInputs = /*@__PURE__*/ proxyCustomElement(class BusinessOwnerFormInputs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            updateFormValues(this.formController, { [name]: value });
        };
        this.onAddressFormUpdate = (values) => {
            updateAddressFormValues(this.formController, Object.assign(Object.assign({}, this.formController.values.getValue().address), values));
        };
        this.ownerDefaultValue = undefined;
        this.errors = undefined;
        this.formController = undefined;
    }
    render() {
        return (h("div", { key: '6fcc165d4bc75b92403d9031ad98f05f6b1dcd34', class: "row gy-3" }, h("div", { key: '74f1e42a13892e95497a99684ba9de64719edb72', class: "col-12 col-md-8" }, h("form-control-text", { key: '29caea2b0b0a62822cc20c99e697f3db7c22a541', name: "name", label: "Full Name", defaultValue: this.ownerDefaultValue.name, errorText: this.errors.name, inputHandler: this.inputHandler })), h("div", { key: '5b0f8da9a0512de70558baa9cb188b4d5e773dc2', class: "col-12 col-md-4" }, h("form-control-text", { key: '40d66a25fbf825fccb2e3c2b6a4b541a6888f5d7', name: "title", label: "Title", defaultValue: this.ownerDefaultValue.title, errorText: this.errors.title, inputHandler: this.inputHandler, helpText: "Role at your business, e.g. President, CEO, Treasurer." })), h("div", { key: '97646974ed1c539e70e602bfc8c42513b0d37c9d', class: "col-12 col-md-6" }, h("form-control-text", { key: '5f4497d54b17f556c74b5c18ea25091306d5b6d6', name: "email", label: "Email Address", defaultValue: this.ownerDefaultValue.email, errorText: this.errors.email, inputHandler: this.inputHandler })), h("div", { key: '9aeb1227cd9afa053d62054222a361f42d20b925', class: "col-12 col-md-6" }, h("form-control-number-masked", { key: 'c97e405262075c980b7e571eb08ab2d9414fb4d5', name: "phone", label: "Phone Number", defaultValue: this.ownerDefaultValue.phone, errorText: this.errors.phone, inputHandler: this.inputHandler, mask: PHONE_MASKS.US })), h("div", { key: '35555ccd9bfa61bbeeb85aa9586c38902b3a08a6', class: "col-12 col-md-4" }, h("form-control-date", { key: '9d865bdf390f2f88a0dc269462b6bce1d2a2675f', name: "dob_full", label: "Birth Date", defaultValue: this.ownerDefaultValue.dob_full, errorText: this.errors.dob_full, inputHandler: this.inputHandler, onFormControlInput: (e) => updateDateOfBirthFormValues(e, this.formController), helpText: "Must be 18 or older." })), h("div", { key: '8a16b08239069ac5ac5273471ab2eeae92a299d7', class: "col-12 col-md-8" }, h("form-control-number-masked", { key: '8e74b1c7fef3087bd842394847c5b4c290be190c', name: "identification_number", label: "SSN", defaultValue: this.ownerDefaultValue.identification_number, errorText: this.errors.identification_number, inputHandler: this.inputHandler, mask: SSN_MASK, helpText: "Enter your full Social Security Number. It is required for Federal OFAC check." })), h("div", { key: 'c07f5293a29e330d2ab62cfa72f5d56e7fdee7cf', class: "col-12" }, h("justifi-identity-address-form", { key: '2b18ebc2f7de2004993d617b80067f55c6d3de4d', errors: this.errors.address, defaultValues: this.ownerDefaultValue.address, handleFormUpdate: this.onAddressFormUpdate }))));
    }
    ;
}, [0, "owner-form-inputs", {
        "ownerDefaultValue": [8, "owner-default-value"],
        "errors": [8],
        "formController": [16]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["owner-form-inputs", "custom-popper", "form-control-date", "form-control-error-text", "form-control-number-masked", "form-control-select", "form-control-text", "form-control-tooltip", "justifi-identity-address-form"];
    components.forEach(tagName => { switch (tagName) {
        case "owner-form-inputs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessOwnerFormInputs);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "form-control-date":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessOwnerFormInputs as B, defineCustomElement as d };
